import { features } from "app/features";
import { isProdEnv } from "lib/routing";
import { JAPI, REDESIGN } from "redux/slices/api/initialisePreferences";
import { hasPreference, useHasPreference } from "pages/preferences/api/useGetPreferences";
import { getAssetClass } from "../publications/api/searchRequest/urlHelpers";
import { ASSET_CLASSES } from "../header/desktop/DesktopHeaderParts/DesktopHeaderParts";

export const useIsRedesign = () => useHasPreference(REDESIGN, "New") && features.redesign;
export const getIsRedesign = () => hasPreference(REDESIGN, "New") && features.redesign;

export const useProdCopyUrl = () => {
  const isProdCopy = useHasPreference(JAPI, "Production");
  return isProdCopy && !isProdEnv ? "japi-prodcopy" : "japi";
};

export const getProdCopyUrl = () => {
  const isProdCopy = hasPreference(JAPI, "Production");
  return isProdCopy && !isProdEnv ? "japi-prodcopy" : "japi";
};

export const isRedesignPage = () => {
  let assetClass = getAssetClass();
  assetClass = assetClass === "SP__Credit" ? "SP/Credit" : assetClass;
  return ASSET_CLASSES.includes(assetClass);
};
